module.exports = __webpack_public_path__ + "static/media/fa-regular-400.89f9806b.svg";